import React, { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';
import styles from './form.module.css';

const SliderForm = ({ content, onSubmit, isPreview = false, isLocked = false, userAnswer = null, allowUpdateResponse = true }) => {
    const min = Number(content?.settings?.min ?? 0);
    const max = Number(content?.settings?.max ?? 100);
    const step = Number(content?.settings?.step ?? 1);
    const midpoint = Math.round((min + max) / 2);

    const [value, setValue] = useState(() => userAnswer?.value ?? midpoint);

    useEffect(() => {
        setValue(userAnswer?.value ?? midpoint);
    }, [userAnswer, midpoint]);

    const hasSubmitted = userAnswer != null;
    const isUnchanged = hasSubmitted && value === userAnswer.value;
    const isDisabled = isLocked || (hasSubmitted && !allowUpdateResponse);
    const submitDisabled = isPreview || isLocked || (hasSubmitted && (!allowUpdateResponse || isUnchanged));
    const submitLabel = !hasSubmitted ? (isLocked ? 'Voting Closed' : 'Submit') : (!allowUpdateResponse || isUnchanged ? 'Submitted ✓' : 'Update response');

    const handleSubmit = () => {
        if (submitDisabled) return;
        onSubmit({ value });
    };

    const pct = max > min ? ((value - min) / (max - min)) * 100 : 0;

    return (
        <div className={styles.form}>
            <div className={styles.question}>
                {content.question || 'Select a value'}
                {isLocked && <span className={styles.lockBadge}><Lock size={12} aria-hidden="true" /> Voting Locked</span>}
            </div>
            {content.settings?.description && content.settings?.descText && (
                <div className={styles.description}>{content.settings.descText}</div>
            )}
            <div className={styles.sliderWrap}>
                <div className={styles.sliderValue}>{value}</div>
                <input
                    type="range"
                    className={styles.sliderInput}
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={(e) => !isDisabled && setValue(Number(e.target.value))}
                    disabled={isDisabled}
                    aria-label={content.question || 'Select a value'}
                />
                <div className={styles.sliderLabelsRow}>
                    <span>{content?.settings?.minLabel || min}</span>
                    <span>{content?.settings?.maxLabel || max}</span>
                </div>
            </div>
            <button className={styles.submitBtn} onClick={handleSubmit} disabled={submitDisabled}>
                {submitLabel}
            </button>
        </div>
    );
};

export default SliderForm;
